import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LaTextInputComponent} from './la-text-input.component';
import {LaInputDirective} from './la-input.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    LaTextInputComponent,
    LaInputDirective,
  ],
  exports: [
    LaTextInputComponent,
    LaInputDirective
  ]
})
export class LaTextInputModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: LaTextInputModule,
      providers: [LaInputDirective]
    };
  }
}
